
import React from 'react';
import './card.css';

function Card({
  widgetName = '',
  title = '',
  name = '',
  size = 'medium',
  style = {},
  applystyle = false,
  applyScroll = false,
  visible = true,
  className = '',
  children,
  component,
  ...rest
}) {
  if (!visible) return null;
  const sizeClass = {
    small: 'card-small',
    medium: 'card-medium',
    large: 'card-large',
  }[size] || '';
  const cardClass = `chart-card-${sizeClass} ${className}`.trim();

  return (
    <div className={cardClass} style={style} data-name={name} {...rest}>
      <div className='chart-header'>
        <div className='chart-title'>
          {title || widgetName}
        </div>
        <div className='card-update-notification'>
          {/* Last updated  {widgetUpdateTime} mins ago */}
        </div>
      </div>
  <hr style={{ marginLeft: '16px', marginRight: '16px' ,opacity:"unset"}} />
      {applyScroll ? (
        <div className="card-content card-content-scroll">
          {children || component}
        </div>
      ) : (
        <div className={applystyle ? 'card-content card-content-even-align' : 'card-content'}>
          {children || component}
        </div>
      )}
    </div>
  );
}

export default Card;


